import React from "react";
import styled from "styled-components";
import media from "utils/media-queries";
import { fontSize } from "styles/theme";
import Section from "components/section";
import LoyolaColorLogo from "../img/color_loyolo_logo";
import r1pc from "../img/r1pc.png";
import winnebagocjcc from "../img/winnebagocjcc.png";
import { color } from "styles/theme";

const FooterText = styled.div`
  width: 50%
  text-align: center;
  font-size: ${fontSize.f3};
  ${media.lg`
    font-size: ${fontSize.f4};
  `}
  ${media.sm`
    text-align: left;
    font-size: ${fontSize.f4};
  `}
`;

const Div = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  flex: 0 0 auto;
  ${media.lg`
  height: ${(props) => (props.article ? "64px" : "")};
  `}
  ${media.sm`
    display: ${(props) => (props.article ? "flex" : "block")};
  `};
  z-index: 10;
  height: ${(props) => (props.article ? "74px" : "")};
  ${media.xs`
    display: block;
    height: 112px;
  `}
`;

export const SvgWrapper = styled.div`
  display: flex;
  flexdirection: row;
  justify-content: center;
  align-items: center;
  min-width: 50px;
  min-height: 50px;
  color: inherit;
  background: inherit;
  flex-item {
    justify-content: center;
  }
`;
const Image = styled.img`
  max-height: 150px;
  max-width: 112px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
`;

function Footer() {
  return (
    <Section>
      <FooterText>
        <p>
          This project is built and maintained by researchers at Loyola
          University Chicago{" "}
          <a href="https://www.luc.edu/ccj/">
            Center for Criminal Justice Research, Policy, and Practice
          </a>
          . It uses a modified open source website. Check it out on{" "}
          <a href="https://github.com/gabdorf/gabriel-adorf-portfolio">
            Github
          </a>
          . Thanks to Gabriel Adorf.
        </p>
      </FooterText>
      <Div>
        <SvgWrapper>
          {" "}
          <Image src={winnebagocjcc} />{" "}
        </SvgWrapper>{" "}
        <SvgWrapper>
          <LoyolaColorLogo></LoyolaColorLogo>{" "}
        </SvgWrapper>
      </Div>
    </Section>
  );
}

export default Footer;
